import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LMSDataService, LmsUserService, UserCourseDataService } from 'lms-api';

import { CourseFilterService } from '../_services/course-filter.service';

@Component({
  selector: 'app-course-list-filter',
  templateUrl: './course-list-filter.component.html',
  styleUrls: ['./course-list-filter.component.scss'],
})
export class CourseListFilterComponent implements OnInit {
  public libraryLastCheckState: any = { ABMP: true, WMC: true };
  public libraryIndeterminateState: any = { ABMP: false, WMC: false };
  public libraryTipText: any = { ABMP: "ABMP Certified, Associate, Professional, and Practitioner members have free access to all courses and CE in the ABMP library. Other learners may purchase courses and CE or join ABMP for access.", WMC: "ABMP Certified and Associate members have free access to the courses and CE in the World Massage Conference (WMC) library. Other learners may purchase courses and CE, upgrade to the Certified level of membership, or join ABMP for access." };
  public courseStatuses;
  public courseTags;
  public courseTypes;
  public courseLibraries;
  public courseCredits;
  public filterForm: UntypedFormGroup;
  public filterGroups: any;
  public activeFilters: { Statuses: boolean, Tags: boolean, Types: boolean, Credits: boolean };
  private initialLoadDone: boolean = false;
  private initialStatusLoadDone: boolean = false;
  private lastStatusCount: number = 0;
  public screenreaderActive: boolean = window.localStorage.getItem('screenreader') == 'true';

  constructor(public courseFilterService: CourseFilterService, public lmsDataService: LMSDataService, public lmsUserService: LmsUserService, private formBuilder: UntypedFormBuilder, public router: Router, public ucdService: UserCourseDataService) {
    this.filterForm = new UntypedFormGroup({});
    this.activeFilters = { Statuses: false, Tags: false, Types: false, Credits: false };
  }

  ngOnInit() {
    this.filterForm.addControl('text:search', new UntypedFormControl());
    this.filterForm.addControl('misc:faves', new UntypedFormControl(false));
    this.filterForm.addControl('misc:paid', new UntypedFormControl(false));

    this.lmsUserService.OnUserStateChange.subscribe(user => {
      user.GetApprovalStates().forEach(state => {
        this.filterForm.addControl('misc:approvedstates_' + state, new UntypedFormControl(false));
      });
    });

    if (this.filterGroups) {
      this.UpdateFilterGroups();
    }

    this.courseFilterService.filterGroupsUpdated.subscribe(filterGroups => {
      if (filterGroups == null) return;
      this.filterGroups = filterGroups;
      this.UpdateFilterGroups();
    });


    this.filterForm.valueChanges.subscribe(formValues => {
      //Iterate the checkboxes and set the correct filter criteria objects
      this.courseFilterService.resetFilterCriteria();
      this.courseFilterService.filterCriteria.Text = formValues.textsearch;

      let anyLibraryChanged = false;
      Object.keys(this.libraryLastCheckState).forEach(changeLibrary => {
        if (!this.initialLoadDone) return;
        if (this.libraryLastCheckState[changeLibrary] != formValues["library:" + changeLibrary]) {
          anyLibraryChanged = true;
          this.libraryLastCheckState[changeLibrary] = formValues["library:" + changeLibrary];
          if (this.filterGroups.Libraries[changeLibrary]) {
            this.filterGroups.Libraries[changeLibrary].types.forEach(typeToSet => {
              let control = this.filterForm.get("type:" + typeToSet) as UntypedFormControl;
              if (control) {
                control.patchValue(this.libraryLastCheckState[changeLibrary]);
              }
            });
          }
        }
      });
      if (anyLibraryChanged) return;

      Object.keys(formValues).forEach(filterFieldName => {
        let filterFieldParts = filterFieldName.split(":");
        let filterFieldType = filterFieldParts[0];
        let filterFieldValue = filterFieldParts[1];
        switch (filterFieldType) {
          case 'status':
            if (formValues[filterFieldName]) {
              this.courseFilterService.filterCriteria.Statuses.push(filterFieldValue);
            }
            break;
          case 'tag':
            if (formValues[filterFieldName]) {
              this.courseFilterService.filterCriteria.Tags.push(filterFieldValue);
            }
            break;
          case 'text':
            this.courseFilterService.filterCriteria.Text = formValues[filterFieldName];
            break;
          case 'type':
            if (formValues[filterFieldName]) {
              this.courseFilterService.filterCriteria.Types.push(filterFieldValue);
            }
            break;
          case 'credits':
            if (formValues[filterFieldName]) {
              this.courseFilterService.filterCriteria.Credits.push(filterFieldValue);
            }
            break;
          case 'misc':
            if (formValues[filterFieldName]) {
              this.courseFilterService.filterCriteria.Miscellany.push(filterFieldValue);
            }
            break;
        }
      });

      Object.keys(this.filterGroups.Libraries).forEach(library => {
        let libraryTypesSelected = 0;
        this.courseFilterService.filterCriteria.Types.forEach(type => {
          if (this.filterGroups.Libraries[library].types.includes(type)) libraryTypesSelected++;
        });
        let libraryControl = this.filterForm.get("library:" + library);
        if (libraryTypesSelected == 0) {
          if (libraryControl) {
            libraryControl.patchValue(false, { emitEvent: false });
          }
          this.libraryIndeterminateState[library] = false;
        } else if (libraryTypesSelected == this.filterGroups.Libraries[library].types.length) {
          if (libraryControl) {
            libraryControl.patchValue(true, { emitEvent: false });
          }
          this.libraryIndeterminateState[library] = false;
        } else {
          this.libraryIndeterminateState[library] = true;
        }
      });

      //For any dropdowns with active filters, set the value
      if (this.courseStatuses) {
        this.activeFilters.Statuses = this.courseFilterService.filterCriteria.Statuses.length > 0 && this.courseFilterService.filterCriteria.Statuses.length != this.courseStatuses.length;
      }
      if (this.courseTags) {
        this.activeFilters.Tags = this.courseFilterService.filterCriteria.Tags.length > 0 && this.courseFilterService.filterCriteria.Tags.length != this.courseTags.length;
      }
      if (this.courseTypes) {
        this.activeFilters.Types = this.courseFilterService.filterCriteria.Types.length > 0 && this.courseFilterService.filterCriteria.Types.length != this.courseTypes.length;
      }
    });
  }

  public UpdateFilterGroups() {
    this.courseStatuses = [];
    if (this.lastStatusCount != Object.keys(this.filterGroups.Statuses).length) {
      this.initialStatusLoadDone = false;
      this.lastStatusCount = Object.keys(this.filterGroups.Statuses).length;
    }
    Object.keys(this.filterGroups.Statuses).sort().forEach(status => {
      this.filterForm.addControl('status:' + status, new UntypedFormControl(!this.initialStatusLoadDone || this.courseFilterService.filterCriteria.Statuses.includes(status)));
      this.courseStatuses.push({ Name: status, CourseCount: this.filterGroups.Statuses[status] });
    });
    this.courseTags = [];
    Object.keys(this.filterGroups.Tags).sort().forEach(tag => {
      this.filterForm.addControl('tag:' + tag, new UntypedFormControl(!this.initialLoadDone || this.courseFilterService.filterCriteria.Tags.includes(tag)));
      this.courseTags.push({ Name: tag, CourseCount: this.filterGroups.Tags[tag] });
    });
    this.courseTypes = [];
    Object.keys(this.filterGroups.Types).sort().forEach(type => {
      this.filterForm.addControl('type:' + type, new UntypedFormControl(!this.initialLoadDone || this.courseFilterService.filterCriteria.Types.includes(type)));
      this.courseTypes.push({ Name: this.filterGroups.Types[type].type, CourseCount: this.filterGroups.Types[type].count, TypeID: this.filterGroups.Types[type].typeid });
    });
    this.courseLibraries = [];
    Object.keys(this.filterGroups.Libraries).sort().forEach(library => {
      this.filterForm.addControl('library:' + library, new UntypedFormControl(!this.initialLoadDone));
      this.courseLibraries.push({ Name: library, CourseCount: this.filterGroups.Libraries[library].count, Types: this.filterGroups.Libraries[library].types });
    });
    this.courseCredits = [];
    Object.keys(this.filterGroups.Credits).sort().forEach(credits => {
      this.filterForm.addControl('credits:' + credits, new UntypedFormControl(!this.initialLoadDone || this.courseFilterService.filterCriteria.Credits.includes(credits)));
      this.courseCredits.push({ Name: credits, CourseCount: this.filterGroups.Credits[credits] });
    });

    this.filterForm.patchValue({ 'text:search': this.courseFilterService.filterCriteria.Text });
    this.initialLoadDone = true;
    this.initialStatusLoadDone = true;
  }

  public toggleFilterDisplay() {
    this.courseFilterService.showFilterUI = !this.courseFilterService.showFilterUI;
    return false;
  }

  public SetAll(prefix, value) {
    for (var controlId in this.filterForm.controls) {
      if (!controlId.startsWith(prefix + ':')) continue;
      this.filterForm.controls[controlId].setValue(value);
    }
    return false;
  }

  public toggleScreenreader() {
    window.localStorage.setItem('screenreader', this.screenreaderActive ? 'false' : 'true');
    this.screenreaderActive = window.localStorage.getItem('screenreader') == 'true';
  }

}
